export default __webpack_public_path__ + "static/media/hierarchy-icon.a0c0c159.svg";